export class DrugRequest {
    name: string;
    category: string;
    qty: number;
    // price: number;
    buying_price: number;
    selling_price: number;
    expiry_period: number;
    manufacturer: string;
    drugId: string;
    // seller_name: string;
    supplier: string;
    rack_no: string;
    instructions: string;
    doctor: string;
    clinic: string;
    mfg_date: string;
    expiry_date: string;
}
